export default __webpack_public_path__ + "static/media/dermaheal4.dbd27777.jpg";